import React, {useEffect, useState} from 'react';

import {
    TextField,
    Button,
    RadioGroup,
    Radio,
    FormControlLabel,
    Select,
    MenuItem,
    FormControl,
    InputLabel, IconButton
} from '@mui/material';

import {Box} from "@mui/system";
import BankSelector from "../../BankOperations/components/BankTransfer/BankSelector";
import {getBanks} from "../../BankOperations/components/BankTransfer/Requisitions";
import DeleteIcon from "@mui/icons-material/Delete";
import Masks from "../../../../components/Shared/Masks";
import axios from 'axios'

// Lista completa de países com bandeira e código de discagem
const countries = [
    { code: 'AF', name: 'Afeganistão', flag: '🇦🇫', dial: '+93' },
    { code: 'ZA', name: 'África do Sul', flag: '🇿🇦', dial: '+27' },
    { code: 'AL', name: 'Albânia', flag: '🇦🇱', dial: '+355' },
    { code: 'DE', name: 'Alemanha', flag: '🇩🇪', dial: '+49' },
    { code: 'AD', name: 'Andorra', flag: '🇦🇩', dial: '+376' },
    { code: 'AO', name: 'Angola', flag: '🇦🇴', dial: '+244' },
    { code: 'AG', name: 'Antígua e Barbuda', flag: '🇦🇬', dial: '+1' },
    { code: 'SA', name: 'Arábia Saudita', flag: '🇸🇦', dial: '+966' },
    { code: 'DZ', name: 'Argélia', flag: '🇩🇿', dial: '+213' },
    { code: 'AR', name: 'Argentina', flag: '🇦🇷', dial: '+54' },
    { code: 'AM', name: 'Armênia', flag: '🇦🇲', dial: '+374' },
    { code: 'AU', name: 'Austrália', flag: '🇦🇺', dial: '+61' },
    { code: 'AT', name: 'Áustria', flag: '🇦🇹', dial: '+43' },
    { code: 'AZ', name: 'Azerbaijão', flag: '🇦🇿', dial: '+994' },
    { code: 'BS', name: 'Bahamas', flag: '🇧🇸', dial: '+1' },
    { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', dial: '+880' },
    { code: 'BB', name: 'Barbados', flag: '🇧🇧', dial: '+1' },
    { code: 'BH', name: 'Bahrein', flag: '🇧🇭', dial: '+973' },
    { code: 'BE', name: 'Bélgica', flag: '🇧🇪', dial: '+32' },
    { code: 'BZ', name: 'Belize', flag: '🇧🇿', dial: '+501' },
    { code: 'BJ', name: 'Benin', flag: '🇧🇯', dial: '+229' },
    { code: 'BT', name: 'Butão', flag: '🇧🇹', dial: '+975' },
    { code: 'BY', name: 'Bielorrússia', flag: '🇧🇾', dial: '+375' },
    { code: 'BO', name: 'Bolívia', flag: '🇧🇴', dial: '+591' },
    { code: 'BA', name: 'Bósnia e Herzegovina', flag: '🇧🇦', dial: '+387' },
    { code: 'BW', name: 'Botsuana', flag: '🇧🇼', dial: '+267' },
    { code: 'BR', name: 'Brasil', flag: '🇧🇷', dial: '+55' },
    { code: 'BN', name: 'Brunei', flag: '🇧🇳', dial: '+673' },
    { code: 'BG', name: 'Bulgária', flag: '🇧🇬', dial: '+359' },
    { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', dial: '+226' },
    { code: 'BI', name: 'Burundi', flag: '🇧🇮', dial: '+257' },
    { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', dial: '+238' },
    { code: 'CM', name: 'Camarões', flag: '🇨🇲', dial: '+237' },
    { code: 'KH', name: 'Camboja', flag: '🇰🇭', dial: '+855' },
    { code: 'CA', name: 'Canadá', flag: '🇨🇦', dial: '+1' },
    { code: 'QA', name: 'Catar', flag: '🇶🇦', dial: '+974' },
    { code: 'KZ', name: 'Cazaquistão', flag: '🇰🇿', dial: '+7' },
    { code: 'TD', name: 'Chade', flag: '🇹🇩', dial: '+235' },
    { code: 'CL', name: 'Chile', flag: '🇨🇱', dial: '+56' },
    { code: 'CN', name: 'China', flag: '🇨🇳', dial: '+86' },
    { code: 'CY', name: 'Chipre', flag: '🇨🇾', dial: '+357' },
    { code: 'CO', name: 'Colômbia', flag: '🇨🇴', dial: '+57' },
    { code: 'KM', name: 'Comores', flag: '🇰🇲', dial: '+269' },
    { code: 'CG', name: 'Congo', flag: '🇨🇬', dial: '+242' },
    { code: 'KP', name: 'Coreia do Norte', flag: '🇰🇵', dial: '+850' },
    { code: 'KR', name: 'Coreia do Sul', flag: '🇰🇷', dial: '+82' },
    { code: 'CI', name: 'Costa do Marfim', flag: '🇨🇮', dial: '+225' },
    { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', dial: '+506' },
    { code: 'HR', name: 'Croácia', flag: '🇭🇷', dial: '+385' },
    { code: 'CU', name: 'Cuba', flag: '🇨🇺', dial: '+53' },
    { code: 'DK', name: 'Dinamarca', flag: '🇩🇰', dial: '+45' },
    { code: 'DJ', name: 'Djibuti', flag: '🇩🇯', dial: '+253' },
    { code: 'DM', name: 'Dominica', flag: '🇩🇲', dial: '+1' },
    { code: 'EG', name: 'Egito', flag: '🇪🇬', dial: '+20' },
    { code: 'SV', name: 'El Salvador', flag: '🇸🇻', dial: '+503' },
    { code: 'AE', name: 'Emirados Árabes Unidos', flag: '🇦🇪', dial: '+971' },
    { code: 'EC', name: 'Equador', flag: '🇪🇨', dial: '+593' },
    { code: 'ER', name: 'Eritreia', flag: '🇪🇷', dial: '+291' },
    { code: 'SK', name: 'Eslováquia', flag: '🇸🇰', dial: '+421' },
    { code: 'SI', name: 'Eslovênia', flag: '🇸🇮', dial: '+386' },
    { code: 'ES', name: 'Espanha', flag: '🇪🇸', dial: '+34' },
    { code: 'US', name: 'Estados Unidos', flag: '🇺🇸', dial: '+1' },
    { code: 'EE', name: 'Estônia', flag: '🇪🇪', dial: '+372' },
    { code: 'ET', name: 'Etiópia', flag: '🇪🇹', dial: '+251' },
    { code: 'FJ', name: 'Fiji', flag: '🇫🇯', dial: '+679' },
    { code: 'PH', name: 'Filipinas', flag: '🇵🇭', dial: '+63' },
    { code: 'FI', name: 'Finlândia', flag: '🇫🇮', dial: '+358' },
    { code: 'FR', name: 'França', flag: '🇫🇷', dial: '+33' },
    { code: 'GA', name: 'Gabão', flag: '🇬🇦', dial: '+241' },
    { code: 'GM', name: 'Gâmbia', flag: '🇬🇲', dial: '+220' },
    { code: 'GH', name: 'Gana', flag: '🇬🇭', dial: '+233' },
    { code: 'GE', name: 'Geórgia', flag: '🇬🇪', dial: '+995' },
    { code: 'GD', name: 'Granada', flag: '🇬🇩', dial: '+1' },
    { code: 'GR', name: 'Grécia', flag: '🇬🇷', dial: '+30' },
    { code: 'GT', name: 'Guatemala', flag: '🇬🇹', dial: '+502' },
    { code: 'GY', name: 'Guiana', flag: '🇬🇾', dial: '+592' },
    { code: 'GN', name: 'Guiné', flag: '🇬🇳', dial: '+224' },
    { code: 'GW', name: 'Guiné-Bissau', flag: '🇬🇼', dial: '+245' },
    { code: 'GQ', name: 'Guiné Equatorial', flag: '🇬🇶', dial: '+240' },
    { code: 'HT', name: 'Haiti', flag: '🇭🇹', dial: '+509' },
    { code: 'NL', name: 'Holanda', flag: '🇳🇱', dial: '+31' },
    { code: 'HN', name: 'Honduras', flag: '🇭🇳', dial: '+504' },
    { code: 'HU', name: 'Hungria', flag: '🇭🇺', dial: '+36' },
    { code: 'YE', name: 'Iêmen', flag: '🇾🇪', dial: '+967' },
    { code: 'IN', name: 'Índia', flag: '🇮🇳', dial: '+91' },
    { code: 'ID', name: 'Indonésia', flag: '🇮🇩', dial: '+62' },
    { code: 'IR', name: 'Irã', flag: '🇮🇷', dial: '+98' },
    { code: 'IQ', name: 'Iraque', flag: '🇮🇶', dial: '+964' },
    { code: 'IE', name: 'Irlanda', flag: '🇮🇪', dial: '+353' },
    { code: 'IS', name: 'Islândia', flag: '🇮🇸', dial: '+354' },
    { code: 'IL', name: 'Israel', flag: '🇮🇱', dial: '+972' },
    { code: 'IT', name: 'Itália', flag: '🇮🇹', dial: '+39' },
    { code: 'JM', name: 'Jamaica', flag: '🇯🇲', dial: '+1' },
    { code: 'JP', name: 'Japão', flag: '🇯🇵', dial: '+81' },
    { code: 'JO', name: 'Jordânia', flag: '🇯🇴', dial: '+962' },
    { code: 'XK', name: 'Kosovo', flag: '🇽🇰', dial: '+383' },
    { code: 'KW', name: 'Kuwait', flag: '🇰🇼', dial: '+965' },
    { code: 'LA', name: 'Laos', flag: '🇱🇦', dial: '+856' },
    { code: 'LS', name: 'Lesoto', flag: '🇱🇸', dial: '+266' },
    { code: 'LV', name: 'Letônia', flag: '🇱🇻', dial: '+371' },
    { code: 'LB', name: 'Líbano', flag: '🇱🇧', dial: '+961' },
    { code: 'LR', name: 'Libéria', flag: '🇱🇷', dial: '+231' },
    { code: 'LY', name: 'Líbia', flag: '🇱🇾', dial: '+218' },
    { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', dial: '+423' },
    { code: 'LT', name: 'Lituânia', flag: '🇱🇹', dial: '+370' },
    { code: 'LU', name: 'Luxemburgo', flag: '🇱🇺', dial: '+352' },
    { code: 'MK', name: 'Macedônia do Norte', flag: '🇲🇰', dial: '+389' },
    { code: 'MG', name: 'Madagascar', flag: '🇲🇬', dial: '+261' },
    { code: 'MY', name: 'Malásia', flag: '🇲🇾', dial: '+60' },
    { code: 'MW', name: 'Malawi', flag: '🇲🇼', dial: '+265' },
    { code: 'MV', name: 'Maldivas', flag: '🇲🇻', dial: '+960' },
    { code: 'ML', name: 'Mali', flag: '🇲🇱', dial: '+223' },
    { code: 'MT', name: 'Malta', flag: '🇲🇹', dial: '+356' },
    { code: 'MA', name: 'Marrocos', flag: '🇲🇦', dial: '+212' },
    { code: 'MU', name: 'Maurício', flag: '🇲🇺', dial: '+230' },
    { code: 'MR', name: 'Mauritânia', flag: '🇲🇷', dial: '+222' },
    { code: 'MX', name: 'México', flag: '🇲🇽', dial: '+52' },
    { code: 'MM', name: 'Mianmar', flag: '🇲🇲', dial: '+95' },
    { code: 'MZ', name: 'Moçambique', flag: '🇲🇿', dial: '+258' },
    { code: 'MD', name: 'Moldávia', flag: '🇲🇩', dial: '+373' },
    { code: 'MC', name: 'Mônaco', flag: '🇲🇨', dial: '+377' },
    { code: 'MN', name: 'Mongólia', flag: '🇲🇳', dial: '+976' },
    { code: 'ME', name: 'Montenegro', flag: '🇲🇪', dial: '+382' },
    { code: 'NA', name: 'Namíbia', flag: '🇳🇦', dial: '+264' },
    { code: 'NP', name: 'Nepal', flag: '🇳🇵', dial: '+977' },
    { code: 'NI', name: 'Nicarágua', flag: '🇳🇮', dial: '+505' },
    { code: 'NE', name: 'Níger', flag: '🇳🇪', dial: '+227' },
    { code: 'NG', name: 'Nigéria', flag: '🇳🇬', dial: '+234' },
    { code: 'NO', name: 'Noruega', flag: '🇳🇴', dial: '+47' },
    { code: 'NZ', name: 'Nova Zelândia', flag: '🇳🇿', dial: '+64' },
    { code: 'OM', name: 'Omã', flag: '🇴🇲', dial: '+968' },
    { code: 'PW', name: 'Palau', flag: '🇵🇼', dial: '+680' },
    { code: 'PS', name: 'Palestina', flag: '🇵🇸', dial: '+970' },
    { code: 'PA', name: 'Panamá', flag: '🇵🇦', dial: '+507' },
    { code: 'PG', name: 'Papua-Nova Guiné', flag: '🇵🇬', dial: '+675' },
    { code: 'PK', name: 'Paquistão', flag: '🇵🇰', dial: '+92' },
    { code: 'PY', name: 'Paraguai', flag: '🇵🇾', dial: '+595' },
    { code: 'PE', name: 'Peru', flag: '🇵🇪', dial: '+51' },
    { code: 'PL', name: 'Polônia', flag: '🇵🇱', dial: '+48' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹', dial: '+351' },
    { code: 'KE', name: 'Quênia', flag: '🇰🇪', dial: '+254' },
    { code: 'KG', name: 'Quirguistão', flag: '🇰🇬', dial: '+996' },
    { code: 'GB', name: 'Reino Unido', flag: '🇬🇧', dial: '+44' },
    { code: 'CF', name: 'República Centro-Africana', flag: '🇨🇫', dial: '+236' },
    { code: 'CZ', name: 'República Tcheca', flag: '🇨🇿', dial: '+420' },
    { code: 'DO', name: 'República Dominicana', flag: '🇩🇴', dial: '+1' },
    { code: 'RO', name: 'Romênia', flag: '🇷🇴', dial: '+40' },
    { code: 'RW', name: 'Ruanda', flag: '🇷🇼', dial: '+250' },
    { code: 'RU', name: 'Rússia', flag: '🇷🇺', dial: '+7' },
    { code: 'SB', name: 'Salomão', flag: '🇸🇧', dial: '+677' },
    { code: 'WS', name: 'Samoa', flag: '🇼🇸', dial: '+685' },
    { code: 'LC', name: 'Santa Lúcia', flag: '🇱🇨', dial: '+1' },
    { code: 'KN', name: 'São Cristóvão e Nevis', flag: '🇰🇳', dial: '+1' },
    { code: 'SM', name: 'São Marino', flag: '🇸🇲', dial: '+378' },
    { code: 'ST', name: 'São Tomé e Príncipe', flag: '🇸🇹', dial: '+239' },
    { code: 'VC', name: 'São Vicente e Granadinas', flag: '🇻🇨', dial: '+1' },
    { code: 'SN', name: 'Senegal', flag: '🇸🇳', dial: '+221' },
    { code: 'SL', name: 'Serra Leoa', flag: '🇸🇱', dial: '+232' },
    { code: 'RS', name: 'Sérvia', flag: '🇷🇸', dial: '+381' },
    { code: 'SG', name: 'Singapura', flag: '🇸🇬', dial: '+65' },
    { code: 'SY', name: 'Síria', flag: '🇸🇾', dial: '+963' },
    { code: 'SO', name: 'Somália', flag: '🇸🇴', dial: '+252' },
    { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', dial: '+94' },
    { code: 'SD', name: 'Sudão', flag: '🇸🇩', dial: '+249' },
    { code: 'SS', name: 'Sudão do Sul', flag: '🇸🇸', dial: '+211' },
    { code: 'SE', name: 'Suécia', flag: '🇸🇪', dial: '+46' },
    { code: 'CH', name: 'Suíça', flag: '🇨🇭', dial: '+41' },
    { code: 'SR', name: 'Suriname', flag: '🇸🇷', dial: '+597' },
    { code: 'TH', name: 'Tailândia', flag: '🇹🇭', dial: '+66' },
    { code: 'TW', name: 'Taiwan', flag: '🇹🇼', dial: '+886' },
    { code: 'TJ', name: 'Tajiquistão', flag: '🇹🇯', dial: '+992' },
    { code: 'TZ', name: 'Tanzânia', flag: '🇹🇿', dial: '+255' },
    { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', dial: '+670' },
    { code: 'TG', name: 'Togo', flag: '🇹🇬', dial: '+228' },
    { code: 'TO', name: 'Tonga', flag: '🇹🇴', dial: '+676' },
    { code: 'TT', name: 'Trinidad e Tobago', flag: '🇹🇹', dial: '+1' },
    { code: 'TN', name: 'Tunísia', flag: '🇹🇳', dial: '+216' },
    { code: 'TM', name: 'Turcomenistão', flag: '🇹🇲', dial: '+993' },
    { code: 'TR', name: 'Turquia', flag: '🇹🇷', dial: '+90' },
    { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', dial: '+688' },
    { code: 'UA', name: 'Ucrânia', flag: '🇺🇦', dial: '+380' },
    { code: 'UG', name: 'Uganda', flag: '🇺🇬', dial: '+256' },
    { code: 'UY', name: 'Uruguai', flag: '🇺🇾', dial: '+598' },
    { code: 'UZ', name: 'Uzbequistão', flag: '🇺🇿', dial: '+998' },
    { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', dial: '+678' },
    { code: 'VA', name: 'Vaticano', flag: '🇻🇦', dial: '+39' },
    { code: 'VE', name: 'Venezuela', flag: '🇻🇪', dial: '+58' },
    { code: 'VN', name: 'Vietnã', flag: '🇻🇳', dial: '+84' },
    { code: 'ZM', name: 'Zâmbia', flag: '🇿🇲', dial: '+260' },
    { code: 'ZW', name: 'Zimbábue', flag: '🇿🇼', dial: '+263' }
];

// Definição dos tipos de chave PIX
const pixTypes = [
    { id: 0, label: "CPF" },
    { id: 1, label: "CNPJ" },
    { id: 2, label: "E-mail" },
    { id: 3, label: "Celular" },
    //{ id: 4, label: "Chave Aleatória" },
];

const RentRecipientFormSet = ({rentRecipients, setRentRecipients, rentRecipient, setRentRecipient, error, setError, ...props}) => {
    const [bankNames, setBankNames] = useState(null)
    const [bankData, setBankData] = useState(null)
    const { index, onChange, onRemove, id, accUpdate, accCreate, deleteAccById, getAcc, ...dataProps } = props;
    const { bank, bank_branch, bank_account, bank_account_digit, bank_account_type, bank_branch_digit } = dataProps
    const [cpfCnpjError, setCpfCnpjError] = useState(null);
    const [recipientData, setRecipientData] = useState(null);

    // Estado para armazenar o tipo de chave PIX selecionado para cada beneficiário
    const [pixTypeStates, setPixTypeStates] = useState([]);

    // Estado para armazenar temporariamente as chaves PIX de cada beneficiário
    const [savedPixKeys, setSavedPixKeys] = useState({});

    useEffect(function bankNames(){
        getBanks(setBankNames)
    }, [])

    const bankOptions = bankNames?.map((option, index) => ({ name: option.name , code: option.code, key: index}))

    // Função para preencher a chave PIX com base no tipo selecionado
    const fillPixKeyBasedOnType = (recipient, type) => {
        const cpfCnpj = recipient.cpf;
        const email = recipient.email;
        const phone = recipient.phone;

        // Determina se é CPF ou CNPJ com base no comprimento
        const cleanedCpfCnpj = cpfCnpj?.replace(/\D/g, '');
        const isCpf = cleanedCpfCnpj && cleanedCpfCnpj.length <= 11;
        const isCnpj = cleanedCpfCnpj && cleanedCpfCnpj.length > 11;

        switch (type) {
            case 0: // CPF
                return isCpf ? cpfCnpj : "";
            case 1: // CNPJ
                return isCnpj ? cpfCnpj : "";
            case 2: // E-mail
                return email || "";
            case 3: // Celular
                return phone || "";
            case 4: // Chave Aleatória
                return ""; // Limpa para chave aleatória
            default:
                return "";
        }
    };

    const addRentRecipient = () => {
        let totalPercent = 0;
        for(let i = 0; i < rentRecipient.length; i++) {
            totalPercent += Number(rentRecipient[i].percent);
        }

        let availablePercent = totalPercent > 100 ? 0 : 100 - totalPercent;

        const newRecipient = {
            name: '',
            cpf: '',
            phone: '',
            email: '',
            percent: availablePercent,
            pix_or_ted: 'PIX',
            pix_key: '',
            pix_type: 0, // Adicionando o tipo de chave PIX
            bank: '',
            branch: '',
            branch_digit: '',
            account: '',
            account_digit: '',
            account_type: '1',
            country: 'BR', // País padrão Brasil
            country_prefix: '+55', // País padrão Brasil
        };

        const newRentRecipient = [...rentRecipient, newRecipient];
        setRentRecipient(newRentRecipient);

        // Adiciona um novo estado de tipo de chave PIX para o novo beneficiário
        setPixTypeStates([...pixTypeStates, 0]);

        // Preenche a chave PIX do novo beneficiário
        setTimeout(() => {
            const idx = rentRecipient.length; // índice do novo
            if (idx < newRentRecipient.length) {
                const pixKey = fillPixKeyBasedOnType(newRecipient, 0);
                createRentRecipient(idx, 'pix_key', pixKey);
            }
        }, 0);
    };

    const createRentRecipient = (index, field, value) => {
        const newRentRecipient = [...rentRecipient];
        if (index >= 0 && index < newRentRecipient.length) {
            newRentRecipient[index][field] = value;
            setRentRecipient(newRentRecipient);
        }
    };

    useEffect(function setBank() {
        if (rentRecipient) {
            setRentRecipients(rentRecipient);
        }
    }, [rentRecipient]);

    // Inicializa os estados de tipo de chave PIX quando o componente é montado
    useEffect(() => {
        if (rentRecipient.length > 0) {
            // Inicializa os estados de tipo de chave PIX
            if (pixTypeStates.length === 0) {
                const initialPixTypes = rentRecipient.map(recipient => recipient.pix_type || 0);
                setPixTypeStates(initialPixTypes);
            }

            // Preenche as chaves PIX para cada beneficiário
            rentRecipient.forEach((recipient, idx) => {
                const pixType = recipient.pix_type || 0;
                const pixKey = fillPixKeyBasedOnType(recipient, pixType);
                if (!recipient.pix_key && recipient.pix_or_ted === 'PIX') {
                    createRentRecipient(idx, 'pix_key', pixKey);
                }
            });
        }
        // eslint-disable-next-line
    }, [rentRecipient.length]);

    const removeRentRecipient = (indexToRemove) => {
        setRentRecipient(rentRecipient.filter((_, index) => index !== indexToRemove));
        // Remove também o estado do tipo de chave PIX correspondente
        setPixTypeStates(pixTypeStates.filter((_, index) => index !== indexToRemove));
        // Remove também a chave PIX salva correspondente
        setSavedPixKeys(prev => {
            const newSaved = {...prev};
            delete newSaved[indexToRemove];
            return newSaved;
        });
    };

    function isValidCPF(cpf) {
        if(typeof cpf !== "string") return false;
        cpf = cpf.replace(/[\s.-]*/gim, '');
        if (
            !cpf ||
            cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999"
        ) {
            return false;
        }
        var soma = 0;
        var resto;
        for (var i = 1; i <= 9; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
        resto = (soma * 10) % 11;
        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(cpf.substring(9, 10)) ) return false;
        soma = 0;
        for (var i = 1; i <= 10; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
        resto = (soma * 10) % 11;
        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(cpf.substring(10, 11) ) ) return false;
        return true;
    }

    function isValidCNPJ(cnpj) {
        if(typeof cnpj !== "string") return false
        cnpj = cnpj.replace(/[\s.-]*/gim, '')

        var pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        var base = 0
        var resultado = 0
        var resto = 0

        if (cnpj.length !== 14)
            return false

        for (var i = 0; i < 12; i++ ) {
            base += (cnpj[i] * pesos[i+1])
        }
        resto = (base % 11)

        if (cnpj[12] != (resto < 2 ? 0 : 11 - resto))
            return false

        base = 0
        resto = 0

        for (var i = 0; i < 13; i++) {
            base += (cnpj[i] * pesos[i])
        }
        resto = (base % 11)

        return cnpj[13] == (resto < 2 ? 0 : 11 - resto)
    }

    function validateCPFAndCNPJ(value) {
        const cleaned = ("" + value).replace(/\D/g, "");
        const isCpf = cleaned.length === 11 && isValidCPF(cleaned);
        const isCnpj = cleaned.length === 14 && isValidCNPJ(cleaned);

        return isCpf || isCnpj;
    }

    const handleCpfCnpjChange = (value) => {
        let cleanValue = value.replace(/\D/g, "");

        if (cleanValue.length > 11) {
            value = Masks?.cnpj(cleanValue);
        } else if (cleanValue.length > 0) {
            value = Masks?.cpf(cleanValue);
        }

        setRecipientData(prevData => ({ ...prevData, cpf: value }));

        if (cleanValue.length >= 11) {
            if (!validateCPFAndCNPJ(cleanValue)) {
                setCpfCnpjError('CPF ou CNPJ inválido');
            } else {
                setCpfCnpjError(null);
            }
        } else {
            setCpfCnpjError(null);
        }
    }

    const formatPixKeyDisplay = (pixKey, cpf) => {
        let cleanedCpfOrCnpj = cpf?.replace(/[^a-zA-Z0-9]/g, "");
        let cleanedPixKey = pixKey?.replace(/[^a-zA-Z0-9]/g, "");

        // Se cleanedPixKey é igual a cleanedCpfOrCnpj verificamos o tamanho e formatamos como cpf ou cnpj.
        if(cleanedPixKey === cleanedCpfOrCnpj){
            if(cleanedPixKey?.length === 11){
                return Masks.cpf(pixKey ?? '');
            }
            else if (cleanedPixKey?.length === 14){
                return Masks.cnpj(pixKey ?? '');
            }
        }
        // Se cleanedPixKey não é igual a cleanedCpfOrCnpj, verificamos se cleanedPixKey é cpf ou cnpj válido.
        else {
            if (cleanedPixKey?.length === 11 && isValidCPF(cleanedPixKey)){
                return Masks.cpf(pixKey ?? '');
            }
            else if (cleanedPixKey?.length === 14 && isValidCNPJ(cleanedPixKey)){
                return Masks.cnpj(pixKey ?? '');
            }
            else if (cleanedPixKey?.length === 11 && (/^\d+$/.test(cleanedPixKey))) {
                return Masks.phone(pixKey ?? '');
            }
        }
        return pixKey;
    };

    // Função para obter os tipos de chave PIX filtrados com base nos dados do beneficiário
    const getFilteredPixTypes = (recipient) => {
        const cpfCnpj = recipient.cpf;
        const email = recipient.email;
        const phone = recipient.phone;

        // Determina se é CPF ou CNPJ com base no comprimento
        const cleanedCpfCnpj = cpfCnpj?.replace(/\D/g, '');
        const isCpf = cleanedCpfCnpj && cleanedCpfCnpj.length <= 11;
        const isCnpj = cleanedCpfCnpj && cleanedCpfCnpj.length > 11;

        return [
            isCpf && { id: 0, label: "CPF" },
            isCnpj && { id: 1, label: "CNPJ" },
            email && { id: 2, label: "E-mail" },
            phone && { id: 3, label: "Celular" },
            // { id: 4, label: "Chave Aleatória" }, // Sempre disponível
        ].filter(Boolean);
    };

    // Handler para mudança de tipo de chave PIX
    const handlePixTypeChange = (index, newType) => {
        // Atualiza o estado do tipo de chave PIX
        const newPixTypeStates = [...pixTypeStates];
        newPixTypeStates[index] = newType;
        setPixTypeStates(newPixTypeStates);

        // Atualiza o tipo de chave PIX no beneficiário
        createRentRecipient(index, 'pix_type', newType);

        // Preenche automaticamente a chave PIX com base no tipo selecionado
        const pixKey = fillPixKeyBasedOnType(rentRecipient[index], newType);
        createRentRecipient(index, 'pix_key', pixKey);
    };

    // Atualiza a chave PIX quando os dados relevantes mudam
    const updatePixKeyIfNeeded = (index, recipient, pixType) => {
        if (recipient.pix_or_ted === 'PIX') {
            const pixKey = fillPixKeyBasedOnType(recipient, pixType);
            createRentRecipient(index, 'pix_key', pixKey);
        }
    };

    // Handler para alternar entre PIX e TED
    const handlePixOrTedChange = (index, value, recipient) => {
        if (value === 'TED') {
            // Salva a chave PIX antes de limpar
            setSavedPixKeys(prev => ({
                ...prev,
                [index]: {
                    pix_key: recipient.pix_key,
                    pix_type: recipient.pix_type
                }
            }));
            // Limpa os campos PIX
            createRentRecipient(index, 'pix_key', '');
            createRentRecipient(index, 'pix_type', 0);
            createRentRecipient(index, 'pix_or_ted', value);
        } else if (value === 'PIX') {
            // Restaura a chave PIX salva, se existir
            const saved = savedPixKeys[index];
            if (saved) {
                createRentRecipient(index, 'pix_key', saved.pix_key);
                createRentRecipient(index, 'pix_type', saved.pix_type);
            }
            createRentRecipient(index, 'pix_or_ted', value);
        }
    };

    const renderRentRecipient = () => {
        return rentRecipient.map((recipient, index) => {
            // Obtém os tipos de chave PIX filtrados para este beneficiário
            const filteredPixTypes = getFilteredPixTypes(recipient);

            // Se não houver tipo de chave definido para este beneficiário, use o primeiro disponível
            if (pixTypeStates.length <= index || pixTypeStates[index] === undefined) {
                const newPixTypeStates = [...pixTypeStates];
                while (newPixTypeStates.length <= index) {
                    newPixTypeStates.push(0);
                }
                setPixTypeStates(newPixTypeStates);

                // Preenche a chave PIX com base no tipo padrão
                if (filteredPixTypes.length > 0) {
                    const defaultType = filteredPixTypes[0].id;
                    setTimeout(() => {
                        createRentRecipient(index, 'pix_type', defaultType);
                        const pixKey = fillPixKeyBasedOnType(recipient, defaultType);
                        createRentRecipient(index, 'pix_key', pixKey);
                    }, 0);
                }
            }

            return (
                <div key={index} style={{border: '1px solid #ccc', padding: '15px', marginBottom: '15px', borderRadius: '10px'}}>
                    <Box display="flex" justifyContent="space-between">
                        <Box>
                            <h4>Beneficiário - {recipient.percent}%</h4>
                        </Box>
                        <Box>
                            <IconButton onClick={() => { removeRentRecipient(index) }}>
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                        <Box width="48%">
                            <TextField
                                label="Nome"
                                fullWidth
                                size={'small'}
                                value={recipient.name}
                                onChange={(e) => {
                                    createRentRecipient(index, 'name', e.target.value)
                                }}
                                style={{marginBottom: '10px'}}
                                error={error !== null}
                                helperText={error?.data?.name}
                            />
                        </Box>
                        <Box width="48%">
                            <TextField
                                label={'CPF / CNPJ'}
                                required
                                state={recipientData}
                                setState={setRecipientData}
                                keyName={'cpf_cnpj'}
                                value={recipient?.cpf}
                                onChange={(e) => {
                                    handleCpfCnpjChange(e.target.value);
                                    const updatedRecipient = {
                                        ...recipient,
                                        cpf: e.target.value
                                    };
                                    createRentRecipient(index, 'cpf', e.target.value);

                                    // Se o tipo de chave atual for CPF ou CNPJ, atualiza a chave PIX
                                    const currentPixType = pixTypeStates[index];
                                    if (currentPixType === 0 || currentPixType === 1) {
                                        setTimeout(() => {
                                            updatePixKeyIfNeeded(index, updatedRecipient, currentPixType);
                                        }, 0);
                                    }
                                }}
                                error={!!cpfCnpjError}
                                helperText={cpfCnpjError}
                                fullWidth
                                size={'small'}
                                sx={{ mb: '1rem'}}
                            />
                        </Box>
                        <Box width="48%" display="flex" alignItems="center" style={{marginBottom: '10px'}}>
                            {/* Select de país com bandeira */}
                            <FormControl size="small" style={{minWidth: 120, marginRight: 8}}>
                                <Select
                                    value={recipient.country || 'BR'}
                                    onChange={e => {
                                        const selectedCountryCode = e.target.value;
                                        const selectedCountry = countries.find(c => c.code === selectedCountryCode);
                                        const prefix = selectedCountry ? selectedCountry.dial : '+55'; // Pega o DDI ou usa +55 como padrão
                                        console.log(selectedCountryCode, prefix)
                                        createRentRecipient(index, 'country', selectedCountryCode);
                                        createRentRecipient(index, 'country_prefix', prefix); // Salva o DDI
                                    }}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        const country = countries.find(c => c.code === selected);
                                        return country ? `${country.flag} ${country.dial}` : '🇧🇷 +55';
                                    }}
                                >
                                    {countries.map((country) => (
                                        <MenuItem key={country.code} value={country.code}>
                                            {country.flag} {country.dial} - {country.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {/* Campo de telefone */}
                            <TextField
                                label="Telefone"
                                fullWidth
                                size={'small'}
                                value={Masks?.phone(String(recipient?.phone)) ?? ''}
                                onChange={(e) => {
                                    const updatedRecipient = {
                                        ...recipient,
                                        phone: e.target.value
                                    };
                                    createRentRecipient(index, 'phone', e.target.value);

                                    // Se o tipo de chave atual for Celular, atualiza a chave PIX
                                    const currentPixType = pixTypeStates[index];
                                    if (currentPixType === 3) {
                                        setTimeout(() => {
                                            updatePixKeyIfNeeded(index, updatedRecipient, currentPixType);
                                        }, 0);
                                    }
                                }}
                            />
                        </Box>
                        <Box width="48%">
                            <TextField
                                label="Email"
                                fullWidth
                                size={'small'}
                                value={recipient.email}
                                onChange={(e) => {
                                    const updatedRecipient = {
                                        ...recipient,
                                        email: e.target.value
                                    };
                                    createRentRecipient(index, 'email', e.target.value);

                                    // Se o tipo de chave atual for E-mail, atualiza a chave PIX
                                    const currentPixType = pixTypeStates[index];
                                    if (currentPixType === 2) {
                                        setTimeout(() => {
                                            updatePixKeyIfNeeded(index, updatedRecipient, currentPixType);
                                        }, 0);
                                    }
                                }}
                                style={{marginBottom: '10px'}}
                                error={error !== null}
                                helperText={error?.data?.email}
                            />
                        </Box>
                        <Box width="48%">
                            <TextField
                                label="Porcentagem"
                                fullWidth
                                size={'small'}
                                value={recipient.percent}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (/^\d*\.?\d*$/.test(value)) {
                                        createRentRecipient(index, 'percent', value);
                                    }
                                }}
                                style={{marginBottom: '10px'}}
                            />
                        </Box>
                    </Box>

                    <h5>Adicionar Chave Pix (PIX) / Conta Bancária (TED)</h5>
                    <RadioGroup
                        row
                        value={recipient.pix_or_ted}
                        onChange={(e) => handlePixOrTedChange(index, e.target.value, recipient)}
                    >
                        <FormControlLabel value="PIX" control={<Radio/>} label="Chave Pix"/>
                        <FormControlLabel value="TED" control={<Radio/>} label="Conta Bancária"/>
                    </RadioGroup>

                    {/* Fields for Pix Key */}
                    {recipient.pix_or_ted === 'PIX' && (
                        <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                            <Box width="48%">
                                <FormControl fullWidth size="small" style={{marginBottom: '10px'}}>
                                    <InputLabel>Tipo da Chave</InputLabel>
                                    <Select
                                        label="Tipo da Chave"
                                        value={pixTypeStates[index] || 0}
                                        onChange={(e) => handlePixTypeChange(index, Number(e.target.value))}
                                    >
                                        {filteredPixTypes.map(opt => (
                                            <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width="48%">
                                <TextField
                                    label="Chave Pix"
                                    fullWidth
                                    size={'small'}
                                    value={formatPixKeyDisplay(recipient.pix_key, recipient.cpf)}
                                    onChange={(e) => {
                                        createRentRecipient(index, 'pix_key', e.target.value)
                                    }}
                                    style={{marginBottom: '10px'}}
                                    error={error !== null}
                                    helperText={error?.data?.pix_key}
                                    disabled={pixTypeStates[index] !== 4} // Só permite edição para Chave Aleatória
                                />
                            </Box>
                        </Box>
                    )}

                    {/* Fields for TED Account */}
                    {recipient.pix_or_ted === 'TED' && (
                        <>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                                <Box width="100%">
                                    <BankSelector
                                        bankNames={bankNames}
                                        reqData={bankData}
                                        setReqData={(bankUpdateFunction) => {
                                            const newBankData = bankUpdateFunction(bankData);
                                            setBankData(newBankData);
                                            createRentRecipient(index, 'bank', newBankData.bank);
                                        }}
                                        defaultValue={bankOptions?.find(e => e?.code === bank?.code)}
                                        value={recipient.bank}
                                        error={error !== null}
                                        helperText={error?.data?.bank}
                                    />
                                </Box>
                                <Box width="48%">
                                    <Box display="flex" justifyContent="space-between">
                                        <TextField
                                            label="Agência"
                                            fullWidth
                                            size={'small'}
                                            value={recipient.branch}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                createRentRecipient(index, 'branch', value);
                                            }}
                                            style={{ width: '48%', marginBottom: '5px' }}
                                            error={error !== null}
                                            helperText={error?.data?.branch}
                                        />
                                        {bankData?.bank === '001' &&
                                            <TextField
                                                label="Digíto"
                                                fullWidth
                                                size={'small'}
                                                value={recipient.branch_digit}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                                    createRentRecipient(index, 'branch_digit', value);
                                                }}
                                                style={{ width: '48%', marginBottom: '5px' }}
                                            />
                                        }
                                    </Box>
                                </Box>
                                <Box width="48%">
                                    <Box display="flex" justifyContent="space-between">
                                        <TextField
                                            label="Conta"
                                            fullWidth
                                            size={'small'}
                                            value={recipient.account}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                createRentRecipient(index, 'account', value);
                                            }}
                                            style={{ width: '48%', marginBottom: '5px' }}
                                            error={error !== null}
                                            helperText={error?.data?.account}
                                        />
                                        <TextField
                                            label="Digíto"
                                            fullWidth
                                            size={'small'}
                                            value={recipient.account_digit}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                createRentRecipient(index, 'account_digit', value);
                                            }}
                                            style={{ width: '48%', marginBottom: '5px' }}
                                            error={error !== null}
                                            helperText={error?.data?.account_digit}
                                        />
                                    </Box>
                                </Box>
                                <Box width="100%" style={{marginBottom: '5px'}}>
                                    <RadioGroup
                                        row
                                        value={recipient.account_type}
                                        onChange={(e) => createRentRecipient(index, 'account_type', e.target.value)}
                                    >
                                        <FormControlLabel value="0" control={<Radio/>} label="Conta Corrente"/>
                                        <FormControlLabel value="1" control={<Radio/>} label="Conta Poupança"/>
                                    </RadioGroup>
                                </Box>
                            </Box>
                        </>
                    )}
                </div>
            );
        });
    };

    // Inicializa as chaves PIX quando o componente é montado
    useEffect(() => {
        if (rentRecipient.length > 0) {
            rentRecipient.forEach((recipient, idx) => {
                if (recipient.pix_or_ted === 'PIX') {
                    const pixType = recipient.pix_type || 0;
                    const pixKey = fillPixKeyBasedOnType(recipient, pixType);
                    if (!recipient.pix_key) {
                        createRentRecipient(idx, 'pix_key', pixKey);
                    }
                }
            });
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            {renderRentRecipient()}
            <Button variant="outlined" color="primary" onClick={addRentRecipient}>
                Adicionar outro beneficiário
            </Button>
        </div>
    );
};

export default RentRecipientFormSet;